import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { TransitionService } from '@uirouter/angular';
import { Subject } from 'rxjs';

/** Adapts router completion events without exposing router-specific types to consumers. */
@Injectable({ providedIn: 'root' })
export class NavigationEventsService implements OnDestroy {
    private readonly succeeded = new Subject<void>();

    /** Future successful page navigations; previous navigations are never replayed. */
    public readonly navigationSucceeded$ = this.succeeded.asObservable();

    private readonly removeSuccessHook: () => void;

    constructor(transitions: TransitionService, zone: NgZone) {
        // Replace this hook with Angular Router NavigationEnd when the router is migrated.
        const removeSuccessHook = transitions.onSuccess({}, () => {
            zone.run(() => this.succeeded.next());
        });
        this.removeSuccessHook = () => removeSuccessHook();
    }

    public ngOnDestroy(): void {
        this.removeSuccessHook();
        this.succeeded.complete();
    }
}